import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NavbarService } from 'src/app/services/navbar-service/navbar.service';

@Component({
    selector: 'app-logged-in-header',
    templateUrl: './logged-in-header.component.html',
    styleUrls: ['./logged-in-header.component.scss'],
    standalone: false
})
export class LoggedInHeaderComponent implements OnInit {
  lgaName: string = '';
  userName = ''
  constructor(
    private authService: AuthService,
    private navbarService: NavbarService,
  ) { }

  isSideNavOpen;

  user: any;

  ngOnInit(): void {
    this.navbarService.getSidebarState().subscribe((isSideNavOpen: boolean) => {
      this.isSideNavOpen = isSideNavOpen;
    })

    this.authService.userSubject.subscribe((user) => {
      this.user = user;
    })

    this.userName = this.authService.getDisplayName().toUpperCase();
    this.lgaName = this.authService.getLgaName().toUpperCase();
  }

  toggleSideNav() {
    this.navbarService.toggleMobileSidebarOpen()
  }

  logout () {
    this.authService.logout()
  }

}
